import { type BlockTableData, table } from '@gitbook/doc-core';

import type { TableRecordSubview } from '../types';

/**
 * Compute the subview of records to display (ordered and filtered).
 */
export function computeRecordsSubview(tableData: BlockTableData): TableRecordSubview {
    const recordKeys = table.defaultRecordSortedKeys(tableData);

    return recordKeys.map((recordKey) => ({
        key: recordKey,
        value: tableData.records[recordKey],
    }));
}
